import { useEffect } from 'react';
import { useQuery as useQueryString } from '@kiper/hooks';
import { steps } from '../steps';
import { readMfaStep } from '../mfaFlowStorage';

/**
 * Pré-preenche o e-mail da query string e pula para o step de senha.
 */
export default function useEmailPrefill({
  formikBag,
  resolveWorkstationAuthorizationRequired,
  setWorkstationAuthorizationRequired,
  setCurrentStep,
  auth,
}) {
  const query = useQueryString();

  useEffect(() => {
    if (query.has('email')) {
      const email = query.get('email');
      formikBag.setFieldValue('email', email);
      resolveWorkstationAuthorizationRequired(email).then(
        ({ workstationAuthorizationRequired: flag }) => {
          setWorkstationAuthorizationRequired(!!flag);
        },
      );
      // Não sobrepõe o step quando o cadastro MFA foi restaurado do F5.
      if (!readMfaStep(steps)) {
        setCurrentStep(steps.password);
      }
    }

    return () => {
      auth.resetFlags();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
